import React, { useState, useRef } from "react";
// import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import dict from "../../Data/dict.json";
import { set_value_properties } from "../../App/actions/propertiesActions";
import C_U_IMG from "../c_edit/C_U_IMG"; // Added import

export default function C_V_IMG({
  value,
  row,
  field,
  inPopup,
  language = "id",
}) {
  // eslint-disable-next-line no-unused-vars
  const [isHovered, setIsHovered] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [previewPos, setPreviewPos] = useState({ top: 0, left: 0 });
  // const [imgLoaded, setImgLoaded] = useState(false);

  // State to handle the FLOAT_MENU anchor for C_U_IMG
  const [uploadAnchor, setUploadAnchor] = useState(null);

  const iconRef = useRef(null);

  const dispatch = useDispatch();
  const layer_state = useSelector((state) => state.layer);

  const properties_state = useSelector((state) => state.properties);

  const mode_map = properties_state.mode_map; // editor || viewer

  const handleMouseEnter = () => {
    if (!value) return;

    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setPreviewPos({
        top: rect.bottom + 5,
        left: rect.left,
      });
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // Triggers the full image modal (C_E_IMG) when the image/text is clicked
  const handleImageClick = (e) => {
    // Only stop propagation if we are inside an inline popup.
    // In the table, we WANT the event to bubble up so the cell gets selected.
    if (inPopup) {
      e.stopPropagation();
    }

    if (value) {
      const geo_layer = layer_state?.geo_layer_list?.find(
        (item) => item?.geo_layer?._id === layer_state?.layer_id,
      )?.geo_layer;
      const fields_image =
        geo_layer?.fields?.filter((f) => f.type === "image") || [];

      dispatch(
        set_value_properties({
          key: "global_image_editor",
          value: { row: row, field: field, fields_image },
        }),
      );
    }
  };

  // Triggers the upload popover (C_U_IMG)
  const handleUploadClick = (e) => {
    // Removed e.stopPropagation() here!
    // This allows the parent cell to "feel" the click and highlight itself.
    setUploadAnchor(e.currentTarget);
  };

  const ImageIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <circle cx="8.5" cy="8.5" r="1.5"></circle>
      <polyline points="21 15 16 10 5 21"></polyline>
    </svg>
  );

  // =========================================================================
  // 1. POPUP MODE (Inline Preview)
  // =========================================================================
  if (inPopup) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {value ? (
          <img
            src={value}
            alt="Preview"
            onClick={handleImageClick}
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              objectFit: "contain",
              cursor: "pointer",
              borderRadius: "6px",
              border: "1px solid #e2e8f0",
              backgroundColor: "#f8fafc",
            }}
          />
        ) : (
          <span className="text_small sub_color" style={{ opacity: 0.5 }}>
            {dict?.["No image"]?.[language] || "No image"}
          </span>
        )}
      </div>
    );
  }

  // =========================================================================
  // 2. TABLE MODE (Hover Portal Preview)
  // =========================================================================
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        gap: "6px",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={iconRef}
    >
      {mode_map === "editor" && (
        <button
          className="button_small hover_primary"
          onClick={handleUploadClick}
        >
          Upload
        </button>
      )}

      {/* THE LIGHTWEIGHT VIEWER */}
      {value ? (
        <div
          onClick={handleImageClick}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
          }}
        >
          <ImageIcon />
          <span
            className="text_small sub_color"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            View Image
          </span>
        </div>
      ) : (
        <span className="text_small sub_color" style={{ opacity: 0.5 }}>
          {dict?.["No image"]?.[language] || "No image"}
        </span>
      )}

      {/* THE UPLOAD POPOVER */}
      {uploadAnchor && (
        <C_U_IMG
          editorState={{ anchorEl: uploadAnchor, row, field }}
          closeEditor={() => setUploadAnchor(null)}
          language={language}
        />
      )}

      {/* THE HOVER PREVIEW */}
      {/* {isHovered &&
        value &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              top: previewPos.top,
              left: previewPos.left,
              zIndex: 9999,
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              padding: "4px",
              borderRadius: "4px",
              pointerEvents: "none",
            }}
          >
            {!imgLoaded && (
              <div
                style={{
                  width: "133px",
                  height: "100px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999",
                  fontSize: "12px",
                }}
              >
                Loading...
              </div>
            )}

            <img
              src={value}
              alt="Preview"
              style={{
                maxWidth: "133px",
                maxHeight: "133px",
                objectFit: "contain",
                display: imgLoaded ? "block" : "none",
              }}
              onLoad={() => setImgLoaded(true)}
            />
          </div>,
          document.body,
        )} */}
    </div>
  );
}
